import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const videos = [
  "https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/bed769ccb6ffaf7f807a6957fe4f37ae.mp4",
  "https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/96b6874721a45768f029a3639206bd42.mp4",
  "https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/d993ca519639ffecb6e4991564870f38.mp4"
];

const customEase = [0.16, 1, 0.3, 1];

export default function LifecycleVideo() {
  const [activeVideo, setActiveVideo] = useState(0);
  const videoRefs = [useRef(null), useRef(null), useRef(null)];

  // Handle sequential playback & bulletproof mobile autoplay
  useEffect(() => {
    videoRefs.forEach((ref, idx) => {
      const video = ref.current;
      if (video) {
        // Force settings at the DOM level to bypass strict mobile policies
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;

        if (idx === activeVideo) {
          video.currentTime = 0;
          video.playbackRate = 1.3; // Sped up a tad bit as requested
          const playPromise = video.play();
          
          if (playPromise !== undefined) {
            playPromise.catch(e => {
              console.log("Auto-play prevented, forcing mute/play again", e);
              // Fallback ensure mute is true if promise rejected
              video.muted = true;
              video.play().catch(err => console.log("Final autoplay rejection", err));
            });
          }
        } else {
          video.pause();
        }
      }
    });
  }, [activeVideo]);

  const handleVideoEnd = () => {
    setActiveVideo((prev) => (prev + 1) % videos.length);
  };

  return (
    <motion.section 
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.4, ease: customEase }}
      className="w-full bg-[#0D0D0D] py-32 sm:py-48 flex flex-col items-center will-change-[transform,opacity]"
    >
      {/* Headlines */}
      <h2 className="text-[#FFFFFF] text-3xl sm:text-4xl font-semibold tracking-tight text-center mb-5 px-4">
        From standby to session complete.
      </h2>
      <p className="text-[#D4D4D8] text-lg sm:text-[19px] font-normal text-center max-w-2xl mx-auto mb-16 px-4 leading-[1.6]">
        Every transition handled automatically. Zero clock-watching for your talent.
      </p>

      {/* Premium Monitor Media Frame - Slightly smaller max-width */}
      <div className="w-full max-w-4xl px-4 sm:px-6">
        <div className="relative w-full aspect-video bg-black rounded-lg sm:rounded-xl border border-[#27272A] overflow-hidden shadow-2xl ring-1 ring-white/5 mx-auto">
          {videos.map((src, idx) => (
            <video
              key={idx}
              ref={videoRefs[idx]}
              className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-500 ease-in-out ${
                idx === activeVideo ? 'opacity-100 z-10' : 'opacity-0 z-0'
              }`}
              src={src}
              muted
              playsInline
              autoPlay={idx === activeVideo}
              onEnded={handleVideoEnd}
            />
          ))}
        </div>
      </div>

      {/* Final Conversion Anchor */}
      <div className="flex flex-col items-center mt-16 px-4">
        <a
          href="https://web.studiotimer.app/#/signup"
          className="inline-flex items-center justify-center px-8 py-3.5 bg-[#FFFFFF] text-[#0D0D0D] text-[15px] font-semibold rounded-[6px] hover:bg-gray-200 transition-all duration-200 ease-apple hover:scale-[1.02] active:scale-[0.98] will-change-transform"
        >
          Create account
        </a>
      </div>
    </motion.section>
  );
}